import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { PrivacyView } from './components/PrivacyView';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
const isPrivacyRoute = window.location.pathname === '/privacidade';

root.render(
  <ErrorBoundary>
    {isPrivacyRoute ? <PrivacyView /> : <App />}
  </ErrorBoundary>
);

// Register Service Worker for PWA support
if ('serviceWorker' in navigator) {
  // ELITE RESET SCRIPT: Força limpeza absoluta em todos os Service Workers velhos!
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('Elite Reset: SW antigo descartado.');
    }
  });

  // Registra o SW de Network-First (novo)
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js?v=v8.1-stable-beta')
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker?.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              window.location.reload();
            }
          });
        });
      })
      .catch(err => console.error('Erro no Elite Reset SW:', err));
  });
}
